import { render, staticRenderFns } from "./LinkPanel.vue?vue&type=template&id=5323553c&scoped=true&"
import script from "./LinkPanel.vue?vue&type=script&lang=ts&"
export * from "./LinkPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LinkPanel.vue?vue&type=style&index=0&id=5323553c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323553c",
  null
  
)

export default component.exports